import React from 'react';

const CORDIALLY_VIDEO_URL =
  'https://customer-assets.emergentagent.com/job_96f73dc0-b292-41dd-a366-8b41de2ebdcc/artifacts/0bj1yigy_Cordially%20Invite%20Vid%20F%204.10.26.mp4';

const HeroSection = () => (
  <div id="hero" style={{
    width: 'calc(100vw + 20px)',
    marginLeft: '-10px',
    paddingTop: 0,
    paddingBottom: 0,
    boxSizing: 'border-box',
    overflow: 'hidden',
  }}>
    <div style={{ overflow: 'hidden', width: '100%', background: '#0D0B08' }}>
      <video
        autoPlay muted loop playsInline
        style={{ width: '100%', display: 'block', height: 'auto' }}
        src={CORDIALLY_VIDEO_URL}
      />
    </div>
  </div>
);

export default HeroSection;
